import axios from "axios";
import { useState } from "react";
import { apiUrl } from "../../common/api/config";
import useFetch from "../../global/hooks/useFetch";
import useMutation from "../../global/hooks/useMutation";

export const useReportTemplates = () => {
  const { data, loading, refetch } = useFetch("/reports/templates/");
  const [deleting, setDeleting] = useState(false);

  const {
    mutate: createTemplateMutation,
    loading: creating,
    error: createError,
  } = useMutation("/reports/templates/", "POST");

  const createTemplate = async (templateData) => {
    const formData = new FormData();
    for (const key in templateData) {
      if (templateData[key] !== null && templateData[key] !== undefined) {
        formData.append(key, templateData[key]);
      }
    }
    const createdTemplate = await createTemplateMutation(formData);
    await refetch();
    return createdTemplate;
  };

  const deleteTemplate = async (id) => {
    setDeleting(true);
    try {
      const token = localStorage.getItem("accessToken");
      await axios.delete(`${apiUrl}/reports/template/${id}/`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });
      await refetch();
    } finally {
      setDeleting(false);
    }
  };

  return {
    templates: data || [],
    loading,
    creating,
    deleting,
    createTemplate,
    deleteTemplate,
    refetch,
    error: createError,
  };
};
